import { render } from "./TariffsFtlItem.vue?vue&type=template&id=12de78e6&scoped=true&ts=true"
import script from "./TariffsFtlItem.vue?vue&type=script&lang=ts"
export * from "./TariffsFtlItem.vue?vue&type=script&lang=ts"

import "./TariffsFtlItem.vue?vue&type=style&index=0&id=12de78e6&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12de78e6"]])

export default __exports__